import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

const CompanyPage = (props) => {
	const { EventCardsRP, TopControlsRP, EventFormRP } = props;

	return (
		<Stack spacing={4}>
			{TopControlsRP && <TopControlsRP />}
			{EventFormRP && <EventFormRP />}
			{EventCardsRP && <EventCardsRP />}
		</Stack>
	);
};

CompanyPage.propTypes = {
	EventCardsRP: PropTypes.elementType,
	TopControlsRP: PropTypes.elementType,
	EventFormRP: PropTypes.elementType,
};

export default CompanyPage;
